import { useMemo } from "react";
import { webPlatform, type AppPlatform } from "../shared/platform.ts";
import { GuardianRoot } from "./GuardianRoot.tsx";

/** The native guardian app (apps/mobile): bearer token in secure storage, push, share, deep links. */
export function GuardianApp({ platform }: { platform: AppPlatform }) {
  return <GuardianRoot platform={platform} client="guardian_app" />;
}

/** The same screens at /guardian/* on the website, on the cookie session. */
export function GuardianWeb() {
  const platform = useMemo(() => webPlatform(), []);
  return <GuardianRoot platform={platform} client="web" />;
}
